// An error whose stack mentions one of these schemes involves browser-extension
// code, which we can neither reproduce nor fix, and whose volume swamps
// first-party errors sharing the same Error Tracking bucket. Safari ships two
// schemes: `safari-extension://` is legacy, `safari-web-extension://` is used
// from Safari 15 on.
export const EXTENSION_URL_SCHEMES = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'safari-web-extension://',
];

// Errors with messages matching these substrings will not be sent to Datadog RUM
export const IGNORED_ERRORS = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications',
  'The map is not a vector map. That will prevent use of data-driven styling.',
  'Attempted to load a Vector Map, but failed. Falling back to Raster.',
  'Ignored attempt to cancel a touchmove event with cancelable=false',
  // Network-level fetch failures (connection drops, navigation aborts,
  // offline devices, VPN/extension interference). Not actionable client-side;
  // backend outages are covered by server-side monitors.
  'Failed to fetch', // Chromium
  'Load failed', // Safari
  'NetworkError when attempting to fetch resource', // Firefox
  // Turbopack's chunk loader re-throws the fetch failures above as a
  // ChunkLoadError with its own message, which escapes the entries above
  'Failed to load chunk',
  // Safari/WebKit rejects all pending promises with this when the page unloads
  'Promise was rejected because the browsing context is going away',
  // Old Safari (16.x) leaks pdf.js's intentional stream cancellation
  // (pdfjs-dist PDFFetchStream, via @side/pdf-renderer) as an unhandled
  // AbortError when the document viewer tears down a render
  'Fetch is aborted', // Safari
  'The operation was aborted.', // Firefox
  'The user aborted a request.', // Chromium
  // Maps script failed to fetch (offline, flaky networks, webviews, China).
  // Real key/billing misconfigs still surface via their "...MapError" errors.
  'The Google Maps JavaScript API could not load.',
  // Maps sub-library chunk failed to fetch after bootstrap loaded
  // (importLibrary "util"/"map"/"places"/…): same flaky-network/webview
  // family as the loader error above; stack is entirely maps.googleapis.com
  'Could not load "',
];
